const initialState = {
    isModalVisible: false,
  };
  
  const privacyModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_PRIVACY_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_PRIVACY_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default privacyModalReducer;
  